import Select from '@components/select';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';

import { Field } from 'components/Field';
import { useStore } from 'hooks/useStore';

import css from './FollowedLoadsPerPageSelect.module.css';

const FollowedLoadsPerPageSelect: FC<TFollowedLoadsPerPageSelectProps> = ({ isRow, containerClassName }) => {
  const {
    app: { i18n },
    followedLoads: { setItemsPerPage },
    ui: { pagination },
  } = useStore();

  return (
    <Field
      containerClassName={containerClassName}
      isRow={isRow}
      labelClassName={css.label}
      labelText={i18n.app.showLines}
    >
      <Select
        className={css.select}
        dropdownWidth={{
          min: '100%',
          current: '100%',
        }}
        labelProperty="label"
        options={pagination.activeFollowedLoadsPerPage.options}
        usePortal={false}
        value={pagination.activeFollowedLoadsPerPage.option}
        onChange={setItemsPerPage}
      />
    </Field>
  );
};

export type TFollowedLoadsPerPageSelectProps = {
  isRow?: boolean;
  containerClassName?: string;
};

const connected = observer(FollowedLoadsPerPageSelect);

export { connected as FollowedLoadsPerPageSelect };
